module.exports = __webpack_public_path__ + "static/gtm-smilee-variable-chatAction-c994c6af6a6c800f0d29bf23b50cfa6d.png";